import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

new Swiper('.default-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 48,
        },
        1024: {
            slidesPerView: 2.25,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 64,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.image-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    loop: true,
    centeredSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.sponsor-carousel', {
    slidesPerView: 3,
    spaceBetween: 60,
    loop: true,
    breakpoints: {
        600: {
            slidesPerView: 5,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 80,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.basic-carousel', {
    slidesPerView: 1.5,
    spaceBetween: 24,
    loop: true,
    breakpoints: {
        600: {
            slidesPerView: 2.5,
            spaceBetween: 48,
        },
        1280: {
            slidesPerView: 4.38,
            spaceBetween: 56,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.upcoming-events-carousel', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
        1280: {
            slidesPerView: 2.25,
        },
    },
});

new Swiper('.social-carousel', {
    slidesPerView: 1.2,
    spaceBetween: 24,
    centeredSlides: true,
    loop: true,
    breakpoints: {
        600: {
            slidesPerView: 3,
            spaceBetween: 48,
            centeredSlides: false,
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 72,
            centeredSlides: false,
        },
    },
});
